<template>
  <div class="container">
    <div class="scrollContainer">
      <!-- <div
        class="homeitem"
        :style="
          activeMenu === '/HomePage' ? 'background: rgb(230, 225, 225);' : ''
        "
        @click="openPath('/HomePage')"
      >
        <i class="el-icon-s-home" />
      </div> -->
      <el-tabs
        v-model="activeTabName"
        type="card"
        @tab-remove="shutMenu"
        @tab-click="handleClickTab"
      >
        <el-tab-pane
          v-for="item in openMenusList"
          :closable="item.menuName !== '首页'"
          :key="item.path"
          :label="item.menuName"
          :name="item.path"
        >
          <span id="homeIcon" v-if="item.menuName === '首页'" slot="label">
            <i style="font-size: 14px" class="el-icon-s-home"></i>
          </span>
        </el-tab-pane>
      </el-tabs>
      <div class="routerClass" :style="{ height: routerHeight }">
        <keep-alive :include="include">
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // activeTabName: ''
      include: ['HomePage']
    }
  },
  methods: {
    // 关闭菜单
    shutMenu (path) {
      const obj = {
        path,
        index: -1
      }
      for (let i = 0; i < this.openMenusList.length; i++) {
        if (this.openMenusList[i]['path'] === path) {
          obj['index'] = i
          break
        }
      }
      this.$store.commit('set_del_menu', obj)
      this.$nextTick(() => {
        const delIncludeIndex = this.include.indexOf(String(path).split('/')[1])
        this.include.splice(delIncludeIndex, 1)
      })
    },
    // 切换菜单
    handleClickTab () {
      this.$router.push({
        name: String(this.activeTabName).split('/')[1]
      })
      // const obj = {
      //   path: this.activeTabName
      // }
      // this.openPath(this.activeTabName)
      // this.$store.commit('set_open_menu', obj)
    }
  },
  computed: {
    activeTabName: {
      get () {
        return this.$store.state.activeMenu
      },
      set (val) {
        this.$store.commit('set_activeMenu', val)
      }
    },
    // activeMenu() {
    //   return this.$store.state.activeMenu
    // },
    openMenusList () {
      return this.$store.state.openMenusList
    },
    routerHeight () {
      return this.mainHeightComputed()
    }
  },
  watch: {
    $route (to) {
      //如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name);
      }
    },
    // include: {
    //   handler (val) {
        // console.log(val)
    //   }
    // }
    // activeMenu: {
    //   handler(newVal) {
    //     const that = this
    //     that.activeTabName = newVal
    //   }
    // }
  }
}
</script>

<style lang='less' scoped>
.container {
  width: 100%;
  height: calc(100% - 1px);
  border-bottom: 1px solid #999;
  background: #f0f7fa;
  position: relative;
  .scrollContainer {
    width: auto;
    height: 100%;
    // display: flex;
    // .homeitem {
    //   height: 27px;
    //   width: 50px;
    //   font-size: 20px;
    //   text-align: center;
    //   line-height: 27px;
    //   border: 1px #e4e7ed solid;
    //   border-bottom: 0;
    //   background: #fff;
    // }
    // .homeitem:hover {
    //   background: rgb(243, 240, 240);
    //   cursor: pointer;
    //   transition: all 0.5s;
    // }
  }
}
.el-tabs {
  width: 100%;
  // width: calc(100% - 50px);
}
/deep/ .el-tabs__header.is-top {
  border-bottom: 1px solid #999 !important;
  padding: 0;
  margin: 0;
}
/deep/ .el-tabs__nav.is-top {
  border: 0;
  height: 29px;
}
//  is-active
/deep/ .el-tabs__item.is-top {
  height: 29px !important;
  border: 0px !important;
  line-height: 29px !important;
}
/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: 0 !important;
}
/deep/ .el-tabs__item.is-top.is-active {
  border-bottom: 1px solid #999 !important;
  background: rgb(230, 225, 225) !important;
  color: #000000;
}
/deep/ .el-tabs__item:hover {
  border-bottom: 1px solid #999 !important;
  color: #000000 !important;
  background: rgb(243, 240, 240) !important;
  transition: background 0.5s !important;
}
/deep/ .el-tabs__nav-wrap.is-scrollable.is-top {
  padding: 0 15px;
}
/deep/ .el-tabs.el-tabs--card.el-tabs--top {
  height: 29px;
}
/deep/ .el-tabs__nav-prev {
  height: 29px;
  line-height: 29px;
  width: 15px;
  text-align: center;
}
/deep/ .el-tabs__nav-next {
  height: 29px;
  line-height: 29px;
  width: 15px;
  text-align: center;
}
.routerClass {
  position: relative;
}
</style>